import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useRoleNameStore } from "../store"

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation()
    const role = useRoleNameStore(state => state.roleName)

    const content = (
        allowedRoles.includes(role)
            ? <Outlet />
            : <Navigate to="/login" state={{ from: location }} replace />
    )

    return content
}
export default RequireAuth